<!-- calendar-display-settings.component.html -->
<mat-card class="configuration-card calendar-settings-card">
  <mat-card-header>
    <mat-card-title>Calendar Display Settings</mat-card-title>
    <mat-card-subtitle>
      Control how the calendar looks and behaves for everyone in your studio.
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="position-relative">
      <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

      <form [formGroup]="settingsForm" *ngIf="!showProgressSpinner" (ngSubmit)="onSubmit()">
        <app-success-message [message]="successMessage"></app-success-message>
        <app-error-message [message]="errorMessage"></app-error-message>

        <div class="settings-grid">

          <!-- Time format -->
          <div class="setting-row">
            <div class="setting-label">
              <span class="setting-name">Time format</span>
              <span class="setting-help">How times are shown across the calendar.</span>
            </div>
            <mat-form-field appearance="outline" class="setting-field">
              <mat-select formControlName="field_time_format">
                <mat-option *ngFor="let opt of timeFormatOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Time increment -->
          <div class="setting-row">
            <div class="setting-label">
              <span class="setting-name">Time increment</span>
              <span class="setting-help">The size of each time slot in day and week views.</span>
            </div>
            <mat-form-field appearance="outline" class="setting-field">
              <mat-select formControlName="field_duration_time_slot">
                <mat-option *ngFor="let opt of timeIncrementOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!--
            HIDDEN UNTIL WIRED INTO FULLCALENDAR.
            These settings save to day_view_settings but the calendar does not read them yet
            (default view, week start, event editing, show weekends, overlap, all-day row).
            Re-enable each block once the corresponding FullCalendar option is wired in
            day-view / base-calendar / week-view via the /api/dayview/calendar/settings endpoint.

          <div class="setting-row">
            <div class="setting-label">
              <span class="setting-name">Default view</span>
              <span class="setting-help">The view shown when the calendar first opens.</span>
            </div>
            <mat-form-field appearance="outline" class="setting-field">
              <mat-select formControlName="field_default_view">
                <mat-option *ngFor="let opt of defaultViewOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="setting-row">
            <div class="setting-label">
              <span class="setting-name">Week starts on</span>
              <span class="setting-help">The first day of each calendar week.</span>
            </div>
            <mat-form-field appearance="outline" class="setting-field">
              <mat-select formControlName="field_week_start">
                <mat-option *ngFor="let opt of weekStartOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="setting-row">
            <div class="setting-label">
              <span class="setting-name">Allow event editing</span>
              <span class="setting-help">Whether events can be moved or resized directly on the calendar.</span>
            </div>
            <mat-form-field appearance="outline" class="setting-field">
              <mat-select formControlName="field_event_editing">
                <mat-option *ngFor="let opt of eventEditingOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          -->

        </div>

        <!--
          HIDDEN UNTIL WIRED (see note above): show weekends, allow overlap, all-day row.
        <div class="settings-toggles">
          <div class="setting-toggle-row">
            <div class="setting-label">
              <span class="setting-name">Show weekends</span>
              <span class="setting-help">Display Saturday and Sunday on the calendar.</span>
            </div>
            <mat-slide-toggle formControlName="field_show_weekends" color="primary"></mat-slide-toggle>
          </div>

          <div class="setting-toggle-row">
            <div class="setting-label">
              <span class="setting-name">Allow overlapping events</span>
              <span class="setting-help">Let events occupy the same time slot.</span>
            </div>
            <mat-slide-toggle formControlName="field_allow_overlap" color="primary"></mat-slide-toggle>
          </div>

          <div class="setting-toggle-row">
            <div class="setting-label">
              <span class="setting-name">Show all-day events row</span>
              <span class="setting-help">Display the all-day band at the top of day and week views.</span>
            </div>
            <mat-slide-toggle formControlName="field_all_day_slot" color="primary"></mat-slide-toggle>
          </div>
        </div>
        -->

        <p class="settings-footnote">
          <mat-icon>schedule</mat-icon>
          <span>
            Working hours and session start times have their own tabs above. Time zone is set under
            <strong>Studio Information</strong>.
          </span>
        </p>
      </form>
    </div>
  </mat-card-content>

  <mat-card-actions align="end" class="calendar-settings-actions">
    <span class="settings-changes-hint" *ngIf="settingsForm.dirty">You have unsaved changes</span>
    <button mat-stroked-button type="button" class="settings-reset-btn" (click)="resetToDefaults()">
      <mat-icon>restart_alt</mat-icon>
      Reset to defaults
    </button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!settingsForm.dirty" (click)="onSubmit()">
      <mat-icon>save</mat-icon>
      Save Settings
    </button>
  </mat-card-actions>
</mat-card>
